<div class="bg-th-blue mt-0 container-fluid py-2">

    <div class=" d-flex justify-content-between align-content-center">

        <i class="fa fa-arrow-left text-secondary my-auto pointer text-white" [routerLink]="['/']"></i>

        <a class=" d-flex align-items-center  text-secondary f18 my-auto text-white">

            <span> ثبت بارنامه </span>

        </a>

    </div>

</div>

<main class="px-2" style="direction: rtl;">

    <div [formGroup]="mdl_Search" class="container-fluid row gx-0 gy-0 mt-3">

        <!-- از تاریخ -->

        <div class="col-12 col-md-2">

            <div class="position-relative w-100 h-100 p-2">

                <label class="mb-2 text-muted"> از تاریخ </label>

                <ng-persian-datepicker [uiTheme]="'gray'" [timeEnable]="false" [dateGregorianFormat]="'YYYY/MM/DD'"
                    [dateInitValue]="true" [dateFormat]="'jYYYY/jMM/jDD'">

                    <input type="text" formControlName="strSDate" placeholder="از تاریخ"
                        class="form-control text-end" />

                </ng-persian-datepicker>

            </div>


        </div>

        <!-- تا تاریخ -->

        <div class="col-12 col-md-2">

            <div class="position-relative w-100 h-100 p-2">

                <label class="mb-2 text-muted"> تا تاریخ </label>

                <ng-persian-datepicker [uiTheme]="'gray'" [timeEnable]="false" [dateGregorianFormat]="'YYYY/MM/DD'"
                    [dateInitValue]="true" [dateFormat]="'jYYYY/jMM/jDD'">

                    <input type="text" formControlName="strEDate" placeholder="از تاریخ"
                        class="form-control text-end" />

                </ng-persian-datepicker>

            </div>

        </div>

        <!-- متحرک -->

        <div class="col-12 col-md-2">

            <div class="position-relative w-100 h-100 p-2">

                <label class="mb-2 text-muted"> متحرک </label>

                <select class="form-select p-2" formControlName="strUnitID">

                    <option class="text-center" value=""> انتخاب کنید </option>

                    <option class="" *ngFor="let item of lstCars" [value]="item.strUnitID">

                        {{ item.strFullName | faNum}}

                    </option>

                </select>

            </div>


        </div>

        <!-- وضعیت -->

        <div class="col-12 col-md-2">

            <div class="position-relative w-100 h-100 p-2">

                <label class="mb-2 text-muted"> وضعیت </label>

                <select class="form-select p-2" formControlName="tiTripStatus">

                    <option class="text-center" value="-1"> انتخاب کنید </option>

                    <option class="text-center" value="0"> منتظر بارگیری </option>

                    <option class="text-center" value="1"> در حال بارگیری </option>

                    <option class="text-center" value="2"> تکمیل بارگیری </option>

                    <option class="text-center" value="3"> خروج از مبداء </option>

                    <option class="text-center" value="4"> ورود به مقصد </option>

                    <option class="text-center" value="5"> تخلیه بار </option>

                    <option class="text-center" value="6"> خروج از مقصد </option>

                </select>

            </div>


        </div>

        <!-- کاربری -->

        <div class="col-12 col-md-2">

            <div class="position-relative w-100 h-100 p-2">

                <label class="mb-2 text-muted"> کاربری </label>

                <select class="form-select p-2" formControlName="tiMobileType">

                    <option class="text-center" value="-1"> انتخاب کنید </option>

                    <option *ngFor="let item of lstMobileType" [value]="item.tiMobileType">

                        {{ item.strComment | faNum}}

                    </option>

                </select>

            </div>


        </div>

        <!-- مبداء/مقصد -->

        <div class="col-12 col-md-2">

            <div class="position-relative w-100 h-100 p-2">

                <label class="mb-2 text-muted"> مبداء/مقصد </label>

                <select class="form-select p-2" formControlName="iSDGeoFence">

                    <option class="text-center" value="-1"> انتخاب کنید </option>

                    <option class="text-center" *ngFor="let item of lst_GeoFence" [value]="item.iGeoFence">

                        {{ item.strTitle }}

                    </option>

                </select>

            </div>

        </div>

        <!-- اهمیت -->

        <div class="col-12 col-md-2">

            <div class="position-relative w-100 h-100 p-2">

                <label class="mb-2 text-muted"> اهمیت </label>

                <select class="form-select p-2" formControlName="tiLoadImportance">

                    <option class="text-center" value="-1"> انتخاب کنید </option>

                    <option class="text-center" value="0"> عادی </option>

                    <option class="text-center" value="1"> مهم </option>

                    <option class="text-center" value="2"> خیلی مهم </option>

                </select>

            </div>

        </div>

        <!-- نتیجه -->

        <div class="col-12 col-md-2">

            <div class="position-relative w-100 h-100 p-2">

                <label class="mb-2 text-muted"> نتیجه </label>

                <select class="form-select p-2" formControlName="tiResultTrip">

                    <option class="text-center" value="-1"> انتخاب کنید </option>

                    <option class="text-center" value="0"> مطابق برنامه ریزی </option>

                    <option class="text-center" value="1"> زودتر از برنامه ریزی </option>

                    <option class="text-center" value="2"> دیرتراز برنامه ریزی </option>

                </select>

            </div>

        </div>

        <!-- جستجو -->

        <div class="col-12 col-md-auto position-relative p-md-2">

            <button class="w-100 btn btn-primary" (click)="seach_barnameh()">

                &nbsp; جستجو &nbsp;

            </button>

        </div>

    </div>

    <div [formGroup]="mdl_Request" class="border border-2 container-fluid row gx-2 gy-2 mt-3 p-2">

        <!-- جستجو -->

        <div class="col-12 col-md-9">

            <input type="text" class="w-100 form-control" placeholder="جستجو کنید ..."
                (input)="filter_Result($event.target)">

        </div>

        <!-- افزودن -->

        <div class="col-12 col-md-auto d-flex align-items-center">

            <button class="btn btn-primary w-100" (click)="addRequest()">

                افزودن

            </button>

        </div>

        <!-- خروجی اکسل -->

        <div class="col-12 col-md-auto d-flex align-items-center">

            <button class="btn btn-success w-100" (click)="exportexcel('Export_Excel')"> خروجی اکسل </button>

        </div>

        <!-- جدول اطلاعات -->

        <div class="section border border-2 mt-2">

            <table class="col-12 table table-striped rounded-3" id="Export_Excel">

                <thead>

                    <tr class="text-center">

                        <th scope="col" class="">#</th>

                        <th scope="col" class=""> عملیات </th>

                        <th scope="col" class="pointer"> کد </th>

                        <th scope="col" class=""> تاریخ </th>

                        <th scope="col" class=""> مبداء </th>

                        <th scope="col" class=""> مقصد </th>

                        <th scope="col" class="pointer"> شماره بارنامه </th>

                        <th scope="col" class="pointer"> نام راننده </th>

                        <th scope="col" class="pointer"> کاربری </th>

                        <th scope="col" class="pointer"> اهمیت</th>

                        <th scope="col" class="pointer"> وضعیت </th>

                        <th scope="col" class="pointer"> نتیجه اجرا </th>


                    </tr>

                </thead>

                <tbody>

                    <tr class="f14 text-center" *ngFor="let item of lst_Routes;let i=index">

                        <th class="text-dark"> {{ i + 1 | faNum }}</th>

                        <th class="">

                            <i class="fa fa-ellipsis-h fa-lg pointer me-2 p-1" id="dropdownMenuButton1"
                                data-bs-toggle="dropdown" aria-expanded="false"></i>

                            <ul class="dropdown-menu" aria-labelledby="dropdownMenuButton1"
                                style="z-index: 10001!important;">

                                <!-- مشاهده -->

                                <li class="dropdown-li" (click)="viewRequest(item)">

                                    <i class="fa fa-eye fa-lg pointer"></i>

                                    <span> مشاهده </span>

                                </li>

                                <!-- ویرایش -->

                                <ng-container *ngIf="item.tiTripStatus >= 0 && item.tiTripStatus <= 2">

                                    <li class="dropdown-li" (click)="addRequest(item,i)">

                                        <i class="fa fa-pencil-square-o fa-lg pointer"></i>

                                        <span> ویرایش </span>

                                    </li>

                                </ng-container>

                                <!-- حذف -->

                                <ng-container *ngIf="item.tiTripStatus == 0">

                                    <li class="dropdown-li" (click)="removeTransit(item,i)">

                                        <i class="fa fa-trash fa-lg" title="حذف" aria-hidden="true"></i>

                                        <span> حذف </span>

                                    </li>

                                </ng-container>

                                <!-- وضعیت -->

                                <ng-container *ngIf="item.tiTripStatus != 6">

                                    <li class="dropdown-li" [ngSwitch]="item?.tiTripStatus" (click)="updateStatus(item,i)">

                                        <i class="fa fa-refresh fa-lg" title="وضعیت" aria-hidden="true"></i>

                                        <span *ngSwitchCase="0"> در حال بارگیری </span>

                                        <span *ngSwitchCase="1"> تکمیل بارگیری </span>

                                        <span *ngSwitchCase="2"> خروج از مبدا </span>

                                        <span *ngSwitchCase="3"> ورود به مقصد </span>

                                        <span *ngSwitchCase="4"> تخلیه بار </span>

                                        <span *ngSwitchCase="5"> خروج از مقصد </span>

                                    </li>

                                </ng-container>

                                <!-- مسیر -->

                                <li class="dropdown-li" (click)="showTripRoute(item)">

                                    <i class="fa fa-road fa-lg" title="مسیر" aria-hidden="true"></i>

                                    <span> مسیر </span>

                                </li>

                                <!-- موقعیت خودرو -->

                                <li class="dropdown-li" (click)="openMap(item)">

                                    <i class="fa fa-map fa-lg" title="موقعیت خودرو" aria-hidden="true"></i>

                                    <span> موقعیت خودرو </span>

                                </li>

                            </ul>

                        </th>

                        <td> {{ item.iTransit_Trip | faNum }} </td>

                        <td> {{ item.strDate | faNum }} </td>

                        <td> {{ item.strSource | faNum }} </td>

                        <td> {{ item.strDestination | faNum }} </td>

                        <td> {{ item.strLoadNo | faNum }} </td>

                        <td> {{ item.strFullName | faNum }} </td>

                        <td> {{ item.strMobileType_strComment | faNum }} </td>

                        <td> {{ item.strLoadImportance | faNum }} </td>

                        <td> {{ item.strTripStatus | faNum }} </td>

                        <td> {{ item.strResultTrip | faNum }} </td>

                    </tr>

                </tbody>

            </table>

        </div>

    </div>

</main>

<!-- مدال افزودن، ویرایش -->

<div class="modal fade" id="addModal" tabindex="-1" aria-labelledby="exampleModalLabel" aria-hidden="true">

    <div class="modal-dialog modal-lg">

        <div class="modal-content dirI">

            <div class="modal-header dirI">

                <h5 class="modal-title" id="exampleModalLabel"> {{ bEditMode ? 'ویرایش' : 'افزودن' }} </h5>

                <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>

            </div>

            <div class="modal-body">

                <div [formGroup]="mdl_Request" class="row gx-0 gy-0">

                    <!-- تاریخ -->

                    <div class="col-md-4 col-12">

                        <div class="position-relative w-100 h-100 p-2">

                            <label> تاریخ </label>

                            <ng-persian-datepicker [uiTheme]="'gray'" [timeEnable]="false"
                                [dateGregorianFormat]="'YYYY/MM/DD'" [dateInitValue]="true"
                                [dateFormat]="'jYYYY/jMM/jDD'">

                                <input type="text" class="form-control text-end" formControlName="strDate" />

                            </ng-persian-datepicker>

                        </div>


                    </div>

                    <!-- مبداء -->

                    <div class="col-md-4 col-12">

                        <div class="position-relative w-100 h-100 p-2">

                            <label class="mb-2 text-muted"> مبداء </label>

                            <select class="form-select p-2" formControlName="iSGeoFence">

                                <option class="text-center" value=""> انتخاب کنید </option>

                                <option class="text-center" *ngFor="let item of lst_GeoFence" [value]="item.iGeoFence">

                                    {{ item.strTitle }}

                                </option>

                            </select>

                        </div>

                    </div>

                    <!-- مقصد -->

                    <div class="col-md-4 col-12">

                        <div class="position-relative w-100 h-100 p-2">

                            <label class="mb-2 text-muted"> مقصد </label>

                            <select class="form-select p-2" formControlName="iDGeoFence">

                                <option class="text-center" value=""> انتخاب کنید </option>

                                <option class="text-center" *ngFor="let item of lst_GeoFence" [value]="item.iGeoFence">

                                    {{ item.strTitle }}

                                </option>

                            </select>

                        </div>

                    </div>

                    <!-- متحرک -->

                    <div class="position-relative col-12 col-md-4 p-2">

                        <label class="text-muted"> متحرک </label>

                        <custom-filter *ngIf="showFilter"
                            [strValue]="returnStrValue('strUnitID',mdl_Request.get('strUnitID')?.value,lstCars,'strFullName')"
                            [strComment]="'strFullName'" [stylesArray]="['padding-top: 10px','text-align: center']"
                            [str_Placeholder]="'متحرک را انتخاب کنید'" [lst_Main]="lstCars"
                            [lst_SearchKey]="['strFullName']" [isDisabled]="mdl_Request.disabled ? true : false"
                            (hideOptions)="setValue_Filter($event,'strUnitID')">

                        </custom-filter>

                    </div>

                    <!-- مدت استاندارد(ساعت) -->

                    <div class="col-md-4 col-12">

                        <div class="position-relative w-100 h-100 p-2">

                            <label class="mb-2 text-muted"> مدت استاندارد(ساعت) </label>

                            <input class="form-control p-2 text-center" formControlName="iStandardTime"
                                oninput="this.value = this.value.replace(/[^0-9]/g,'')">

                        </div>

                    </div>

                    <!-- مدت توقف استاندارد(دقیقه) -->

                    <div class="col-md-4 col-12">

                        <div class="position-relative w-100 h-100 p-2">

                            <label class="mb-2 text-muted"> مدت توقف استاندارد(دقیقه) </label>

                            <input class="form-control p-2 text-center" formControlName="iStandardStop"
                                oninput="this.value = this.value.replace(/[^0-9]/g,'')">

                        </div>

                    </div>

                    <!-- اهمیت -->

                    <div class="col-md-4 col-12">

                        <div class="position-relative w-100 h-100 p-2">

                            <label class="mb-2 text-muted"> اهمیت </label>

                            <select class="form-select p-2" formControlName="tiLoadImportance">

                                <option class="text-center" value=""> انتخاب کنید </option>

                                <option class="text-center" value="0"> عادی </option>

                                <option class="text-center" value="1"> مهم </option>

                                <option class="text-center" value="2"> خیلی مهم </option>

                            </select>

                        </div>

                    </div>

                    <!-- شماره بارنامه -->

                    <div class="col-md-4 col-12">

                        <div class="position-relative w-100 h-100 p-2">

                            <label class="mb-2 text-muted"> شماره بارنامه </label>

                            <input class="form-control p-2 text-end" formControlName="strLoadNo">

                        </div>

                    </div>


                    <!-- کرایه(ریال)  -->

                    <div class="col-md-4 col-12">

                        <div class="position-relative w-100 h-100 p-2">

                            <label class="mb-2 text-muted"> کرایه(ریال) </label>

                            <input class="form-control p-2 text-center" formControlName="iRent"
                                oninput="this.value = this.value.replace(/[^0-9]/g,'').toString().replace(/\B(?=(\d{3})+(?!\d))/g, ',')">

                        </div>

                    </div>

                    <!-- موبایل مشتری -->

                    <div class="col-md-4 col-12">

                        <div class="position-relative w-100 h-100 p-2">

                            <label class="mb-2 text-muted"> موبایل مشتری </label>

                            <input class="form-control p-2 text-center" formControlName="strClientMobile" maxlength="11"
                                oninput="this.value = this.value.replace(/[^0-9]/g,'')">

                        </div>

                    </div>

                    <!-- توضیحات بار -->

                    <div class="position-relative col-12 p-2">

                        <label class="mb-2 text-muted"> توضیحات بار </label>

                        <textarea style="height: 70px;resize: none;" class="form-control"
                            formControlName="strLoadDetail"></textarea>

                    </div>

                    <!-- توضیحات تکمیلی -->

                    <div class="position-relative col-12 p-2">

                        <label class="mb-2 text-muted"> توضیحات تکمیلی </label>

                        <textarea style="height: 100px;resize: none;" class="form-control"
                            formControlName="strComment"></textarea>

                    </div>

                </div>

            </div>

            <div class="modal-footer d-flex justify-content-start">

                <button class="btn" [ngClass]="bEditMode ? 'btn-primary' : 'btn-success' " (click)="submitRequest()">

                    &nbsp; {{ bEditMode ? 'ویرایش' : 'ذخیره' }} &nbsp;

                </button>

                <button class="btn btn-outline-secondary" data-bs-dismiss="modal">

                    &nbsp; بستن &nbsp;

                </button>

            </div>

        </div>

    </div>

</div>

<!-- مدال مشاهده -->

<div class="modal fade" id="viewModal" tabindex="-1" aria-labelledby="exampleModalLabel" aria-hidden="true">

    <div class="modal-dialog modal-lg">

        <div class="modal-content dirI">

            <div class="modal-header dirI">

                <h5 class="modal-title" id="exampleModalLabel"> مشاهده </h5>

                <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>

            </div>

            <div class="modal-body" style="max-height: 65vh;overflow-y: auto;">

                <div [formGroup]="mdl_View" class="row gx-0 gy-0">

                    <!-- تاریخ -->

                    <div class="col-md-4 col-12">

                        <div class="position-relative w-100 h-100 p-2">

                            <label> تاریخ </label>

                            <ng-persian-datepicker [uiTheme]="'gray'" [timeEnable]="false"
                                [dateGregorianFormat]="'YYYY/MM/DD'" [dateInitValue]="true"
                                [dateFormat]="'jYYYY/jMM/jDD'">

                                <input type="text" class="form-control text-end" formControlName="strDate" />

                            </ng-persian-datepicker>

                        </div>


                    </div>

                    <!-- مبداء -->

                    <div class="col-md-4 col-12">

                        <div class="position-relative w-100 h-100 p-2">

                            <label class="mb-2 text-muted"> مبداء </label>

                            <select class="form-select p-2" formControlName="iSGeoFence">

                                <option class="text-center" value=""> انتخاب کنید </option>

                                <option class="text-center" *ngFor="let item of lst_GeoFence" [value]="item.iGeoFence">

                                    {{ item.strTitle }}

                                </option>

                            </select>

                        </div>

                    </div>

                    <!-- مقصد -->

                    <div class="col-md-4 col-12">

                        <div class="position-relative w-100 h-100 p-2">

                            <label class="mb-2 text-muted"> مقصد </label>

                            <select class="form-select p-2" formControlName="iDGeoFence">

                                <option class="text-center" value=""> انتخاب کنید </option>

                                <option class="text-center" *ngFor="let item of lst_GeoFence" [value]="item.iGeoFence">

                                    {{ item.strTitle }}

                                </option>

                            </select>

                        </div>

                    </div>

                    <!-- متحرک -->

                    <div class="col-md-4 col-12">

                        <div class="position-relative w-100 h-100 p-2">

                            <label class="mb-2 text-muted"> متحرک </label>

                            <select class="form-select p-2" formControlName="strUnitID">

                                <option class="text-center" value=""> انتخاب کنید </option>

                                <option class="text-center" *ngFor="let item of lstCars" [value]="item.strUnitID">

                                    {{ item.strFullName | faNum}}

                                </option>

                            </select>

                        </div>


                    </div>

                    <!-- مدت استاندارد(ساعت) -->

                    <div class="col-md-4 col-12">

                        <div class="position-relative w-100 h-100 p-2">

                            <label class="mb-2 text-muted"> مدت استاندارد(ساعت) </label>

                            <input class="form-control p-2 text-center" formControlName="iStandardTime"
                                oninput="this.value = this.value.replace(/[^0-9]/g,'')">

                        </div>

                    </div>

                    <!-- مدت توقف استاندارد(دقیقه) -->

                    <div class="col-md-4 col-12">

                        <div class="position-relative w-100 h-100 p-2">

                            <label class="mb-2 text-muted"> مدت توقف استاندارد(دقیقه) </label>

                            <input class="form-control p-2 text-center" formControlName="iStandardStop"
                                oninput="this.value = this.value.replace(/[^0-9]/g,'')">

                        </div>

                    </div>

                    <!-- شماره بارنامه -->

                    <div class="col-md-4 col-12">

                        <div class="position-relative w-100 h-100 p-2">

                            <label class="mb-2 text-muted"> شماره بارنامه </label>

                            <input class="form-control p-2 text-end" formControlName="strLoadNo">

                        </div>

                    </div>

                    <!-- اهمیت -->

                    <div class="col-md-4 col-12">

                        <div class="position-relative w-100 h-100 p-2">

                            <label class="mb-2 text-muted"> اهمیت </label>

                            <select class="form-select p-2" formControlName="tiLoadImportance">

                                <option class="text-center" value=""> انتخاب کنید </option>

                                <option class="text-center" value="0"> عادی </option>

                                <option class="text-center" value="1"> مهم </option>

                                <option class="text-center" value="2"> خیلی مهم </option>

                            </select>

                        </div>

                    </div>

                    <!-- کرایه(ریال)  -->

                    <div class="col-md-4 col-12">

                        <div class="position-relative w-100 h-100 p-2">

                            <label class="mb-2 text-muted"> کرایه(ریال) </label>

                            <input class="form-control p-2 text-center" formControlName="iRent"
                                oninput="this.value = this.value.replace(/[^0-9]/g,'').toString().replace(/\B(?=(\d{3})+(?!\d))/g, ',')">

                        </div>

                    </div>

                    <!-- موبایل مشتری -->

                    <div class="col-md-4 col-12">

                        <div class="position-relative w-100 h-100 p-2">

                            <label class="mb-2 text-muted"> موبایل مشتری </label>

                            <input class="form-control p-2 text-center" formControlName="strClientMobile" maxlength="11"
                                oninput="this.value = this.value.replace(/[^0-9]/g,'')">

                        </div>

                    </div>

                    <!-- وضعیت -->

                    <div class="col-md-4 col-12">

                        <div class="position-relative w-100 h-100 p-2">

                            <label class="mb-2 text-muted"> وضعیت </label>

                            <input class="form-control p-2 text-center" formControlName="strTripStatus">

                        </div>

                    </div>

                    <!-- زمان تکمیل بارگیری  -->

                    <div class="col-md-4 col-12">

                        <div class="position-relative w-100 h-100 p-2">

                            <label class="mb-2 text-muted"> زمان تکمیل بارگیری </label>

                            <input class="form-control p-2 text-center" formControlName="strLoadingTime">

                        </div>

                    </div>

                    <!-- زمان تخلیه  -->

                    <div class="col-md-4 col-12">

                        <div class="position-relative w-100 h-100 p-2">

                            <label class="mb-2 text-muted"> زمان تحلیه </label>

                            <input class="form-control p-2 text-center" formControlName="strDischargeTime">

                        </div>

                    </div>

                    <!-- زمان ورود به مبداء  -->

                    <div class="col-md-4 col-12">

                        <div class="position-relative w-100 h-100 p-2">

                            <label class="mb-2 text-muted"> زمان ورود به مبداء </label>

                            <input class="form-control p-2 text-center" formControlName="strSEntryDateTime">

                        </div>

                    </div>

                    <!-- زمان خروج از مبداء  -->

                    <div class="col-md-4 col-12">

                        <div class="position-relative w-100 h-100 p-2">

                            <label class="mb-2 text-muted"> زمان خروج از مبداء </label>

                            <input class="form-control p-2 text-center" formControlName="strSExitDateTime">

                        </div>

                    </div>

                    <!-- مدت حضور در مبداء  -->

                    <div class="col-md-4 col-12">

                        <div class="position-relative w-100 h-100 p-2">

                            <label class="mb-2 text-muted"> مدت حضور در مبداء </label>

                            <input class="form-control p-2 text-center" formControlName="strSDuration">

                        </div>

                    </div>

                    <!-- زمان ورود به مقصد  -->

                    <div class="col-md-4 col-12">

                        <div class="position-relative w-100 h-100 p-2">

                            <label class="mb-2 text-muted"> زمان ورود به مقصد </label>

                            <input class="form-control p-2 text-center" formControlName="strDEntryDateTime">

                        </div>

                    </div>

                    <!-- زمان خروج از مقصد  -->

                    <div class="col-md-4 col-12">

                        <div class="position-relative w-100 h-100 p-2">

                            <label class="mb-2 text-muted"> زمان خروج از مقصد </label>

                            <input class="form-control p-2 text-center" formControlName="strDExitDateTime">

                        </div>

                    </div>

                    <!-- مدت حضور در مقصد  -->

                    <div class="col-md-4 col-12">

                        <div class="position-relative w-100 h-100 p-2">

                            <label class="mb-2 text-muted"> مدت حضور در مقصد </label>

                            <input class="form-control p-2 text-center" formControlName="strDDuration">

                        </div>

                    </div>

                    <!-- پیمایش کل  -->

                    <div class="col-md-4 col-12">

                        <div class="position-relative w-100 h-100 p-2">

                            <label class="mb-2 text-muted"> پیمایش کل </label>

                            <input class="form-control p-2 text-center" formControlName="iTripKm">

                        </div>

                    </div>

                    <!-- مدت کل  -->

                    <div class="col-md-4 col-12">

                        <div class="position-relative w-100 h-100 p-2">

                            <label class="mb-2 text-muted"> مدت کل </label>

                            <input class="form-control p-2 text-center" formControlName="strResultTime">

                        </div>

                    </div>

                    <!-- تعداد توقف  -->

                    <div class="col-md-4 col-12">

                        <div class="position-relative w-100 h-100 p-2">

                            <label class="mb-2 text-muted"> تعداد توقف </label>

                            <input class="form-control p-2 text-center" formControlName="iStops">

                        </div>

                    </div>

                    <!-- مدت توقف  -->

                    <div class="col-md-4 col-12">

                        <div class="position-relative w-100 h-100 p-2">

                            <label class="mb-2 text-muted"> مدت توقف </label>

                            <input class="form-control p-2 text-center" formControlName="strStopsTime">

                        </div>

                    </div>

                    <!-- متوسط سرعت(km)  -->

                    <div class="col-md-4 col-12">

                        <div class="position-relative w-100 h-100 p-2">

                            <label class="mb-2 text-muted"> متوسط سرعت(km) </label>

                            <input class="form-control p-2 text-center" formControlName="iAverageSpeed">

                        </div>

                    </div>

                    <!-- نتیجه ارزیابی  -->

                    <div class="col-md-4 col-12">

                        <div class="position-relative w-100 h-100 p-2">

                            <label class="mb-2 text-muted"> نتیجه ارزیابی </label>

                            <input class="form-control p-2 text-center" formControlName="strResultTrip">

                        </div>

                    </div>

                    <!-- توضیحات بار -->

                    <div class="position-relative col-12 p-2">

                        <label class="mb-2 text-muted"> توضیحات بار </label>

                        <textarea style="height: 70px;resize: none;" class="form-control"
                            formControlName="strLoadDetail"></textarea>

                    </div>

                    <!-- توضیحات تحویل گیرنده -->

                    <div class="position-relative col-12 p-2">

                        <label class="mb-2 text-muted"> توضیحات تحویل گیرنده </label>

                        <textarea style="height: 70px;resize: none;" class="form-control"
                            formControlName="strReceiverComment"></textarea>

                    </div>

                    <!-- توضیحات تکمیلی -->

                    <div class="position-relative col-12 p-2">

                        <label class="mb-2 text-muted"> توضیحات تکمیلی </label>

                        <textarea style="height: 100px;resize: none;" class="form-control"
                            formControlName="strComment"></textarea>

                    </div>

                </div>

            </div>

            <div class="modal-footer d-flex justify-content-start">

                <button class="btn btn-outline-secondary" data-bs-dismiss="modal">

                    &nbsp; بستن &nbsp;

                </button>

            </div>

        </div>

    </div>

</div>